// extracted by mini-css-extract-plugin
export default {"spinner-screen":"wR9Z5GgJrf0Q6R6wgMwL"};